(function () {
  'use strict';

  function toggleModal(modal, show) {
    if (!modal) return;
    modal.hidden = !show;
    document.body.style.overflow = show ? 'hidden' : '';
  }

  function syncHeaderOffset() {
    var header = document.querySelector('[data-vy-header]');
    var topbar = document.querySelector('.vy-topbar');
    if (!header) return;

    var bottom = 0;
    if (topbar) {
      bottom = Math.max(bottom, topbar.getBoundingClientRect().bottom);
    }
    bottom = Math.max(bottom, header.getBoundingClientRect().bottom);

    // When header is scrolled away / hidden, keep the resting offset from heights.
    if (document.body.classList.contains('vy-header-hidden') || bottom < 40) {
      var topbarH = topbar ? topbar.offsetHeight : 34;
      bottom = topbarH + header.offsetHeight;
    }

    document.documentElement.style.setProperty(
      '--vy-header-offset',
      Math.ceil(bottom) + 'px'
    );
  }

  function initHeader() {
    var header = document.querySelector('[data-vy-header]');
    if (!header) return;

    var lastY = window.scrollY;
    var ticking = false;

    function update() {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 48);

      var goingDown = y > lastY;
      var delta = Math.abs(y - lastY);

      if (y <= 80) {
        document.body.classList.remove('vy-header-hidden');
      } else if (delta > 6) {
        if (goingDown) {
          document.body.classList.add('vy-header-hidden');
        } else {
          document.body.classList.remove('vy-header-hidden');
        }
      }

      lastY = y;
      ticking = false;
    }

    syncHeaderOffset();
    update();
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
    window.addEventListener('resize', syncHeaderOffset, { passive: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncHeaderOffset).catch(function () {});
    }
  }

  function initMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var menu = document.querySelector('[data-mobile-menu]');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', function () {
      var isOpen = !menu.hidden;
      toggleModal(menu, !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });

    menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
      el.addEventListener('click', function () {
        toggleModal(menu, false);
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function initHeaderNav() {
    var header = document.querySelector('[data-vy-header]');
    if (!header) return;

    var mq = window.matchMedia('(min-width: 990px)');
    var items = header.querySelectorAll('.vy-header__item--has-children');
    var closeTimer = null;

    function closeAll() {
      items.forEach(function (item) {
        item.classList.remove('is-open');
        var trigger = item.querySelector('.vy-header__flyout > a');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      });
    }

    function openItem(item) {
      if (!mq.matches) return;
      clearTimeout(closeTimer);
      items.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('is-open');
          var t = other.querySelector('.vy-header__flyout > a');
          if (t) t.setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.add('is-open');
      var trigger = item.querySelector('.vy-header__flyout > a');
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }

    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(closeAll, 120);
    }

    items.forEach(function (item) {
      if (item.dataset.navBound === 'true') return;

      var flyout = item.querySelector('[data-nav-flyout]');
      var trigger = flyout && flyout.querySelector('a');
      if (trigger) {
        trigger.setAttribute('aria-haspopup', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        trigger.addEventListener('click', function (event) {
          if (!mq.matches) return;
          if (item.classList.contains('is-open')) return;
          event.preventDefault();
          openItem(item);
        });
      }

      item.dataset.navBound = 'true';
      item.addEventListener('pointerenter', function () { openItem(item); });
      item.addEventListener('pointerleave', function (event) {
        var next = event.relatedTarget;
        if (next && item.contains(next)) return;
        scheduleClose();
      });
      item.addEventListener('focusin', function () { openItem(item); });
    });

    header.addEventListener('pointerleave', function (event) {
      if (!mq.matches) return;
      var next = event.relatedTarget;
      if (next && header.contains(next)) return;
      scheduleClose();
    });

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', function () { closeAll(); });
    }
  }

  function initSearch() {
    var toggles = document.querySelectorAll('[data-search-toggle]');
    var modal = document.querySelector('[data-search-modal]');
    if (!toggles.length || !modal) return;

    var input = modal.querySelector('[data-vy-search-input]');
    var clearBtn = modal.querySelector('[data-vy-search-clear]');
    var idle = modal.querySelector('[data-vy-search-idle]');
    var status = modal.querySelector('[data-vy-search-status]');
    var results = modal.querySelector('[data-vy-search-results]');
    var list = modal.querySelector('[data-vy-search-list]');
    var countEl = modal.querySelector('[data-vy-search-count]');
    var allLink = modal.querySelector('[data-vy-search-all]');
    var debounceTimer = null;
    var activeController = null;
    var lastQuery = '';

    function setExpanded(open) {
      toggles.forEach(function (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
      });
    }

    function openSearch() {
      toggleModal(modal, true);
      setExpanded(true);
      window.setTimeout(function () {
        if (input) {
          input.focus();
          input.select();
        }
      }, 30);
    }

    function closeSearch() {
      toggleModal(modal, false);
      setExpanded(false);
      if (activeController) {
        activeController.abort();
        activeController = null;
      }
    }

    function formatMoney(amount) {
      var n = Number(amount);
      if (!isFinite(n)) return '';
      try {
        return new Intl.NumberFormat('de-CH', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'CHF'
        }).format(n);
      } catch (e) {
        return n.toFixed(2);
      }
    }

    function showIdle() {
      if (idle) idle.hidden = false;
      if (status) status.hidden = true;
      if (results) results.hidden = true;
      if (list) list.innerHTML = '';
    }

    function showStatus(message) {
      if (idle) idle.hidden = true;
      if (results) results.hidden = true;
      if (list) list.innerHTML = '';
      if (status) {
        status.hidden = false;
        status.textContent = message;
      }
    }

    function renderProducts(products, query) {
      if (!list || !results) return;
      if (idle) idle.hidden = true;
      if (status) status.hidden = true;
      results.hidden = false;
      list.innerHTML = '';

      if (countEl) {
        countEl.textContent = products.length === 1
          ? '1 Ergebnis'
          : products.length + ' Ergebnisse';
      }
      if (allLink) {
        allLink.hidden = false;
        allLink.href = '/search?type=product&q=' + encodeURIComponent(query);
      }

      products.forEach(function (product) {
        var li = document.createElement('li');
        li.className = 'vy-search__item';
        li.setAttribute('role', 'option');

        var url = product.url || ('/products/' + product.handle);
        var image = (product.featured_image && product.featured_image.url) || product.image || '';
        var price = product.price_min || product.price || '';
        var typeLabel = product.type || '';

        li.innerHTML =
          '<a class="vy-search__link" href="' + url + '">' +
            (image
              ? '<img class="vy-search__thumb" src="' + image + '" alt="" width="64" height="80" loading="lazy">'
              : '<span class="vy-search__thumb-fallback" aria-hidden="true"></span>') +
            '<span class="vy-search__meta">' +
              '<span class="vy-search__name"></span>' +
              (typeLabel ? '<span class="vy-search__type"></span>' : '') +
            '</span>' +
            '<span class="vy-search__price"></span>' +
          '</a>';

        li.querySelector('.vy-search__name').textContent = product.title || '';
        if (typeLabel) li.querySelector('.vy-search__type').textContent = typeLabel;
        li.querySelector('.vy-search__price').textContent = formatMoney(price);
        list.appendChild(li);
      });
    }

    function runPredictive(query) {
      lastQuery = query;
      if (clearBtn) clearBtn.hidden = query.length === 0;

      if (query.length < 2) {
        showIdle();
        return;
      }

      showStatus('Suche …');
      if (activeController) activeController.abort();
      activeController = typeof AbortController !== 'undefined' ? new AbortController() : null;

      var endpoint = '/search/suggest.json?q=' + encodeURIComponent(query) +
        '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';

      fetch(endpoint, {
        headers: { Accept: 'application/json' },
        signal: activeController ? activeController.signal : undefined
      })
        .then(function (res) {
          if (!res.ok) throw new Error('search failed');
          return res.json();
        })
        .then(function (data) {
          if (query !== lastQuery) return;
          var products = (((data || {}).resources || {}).results || {}).products || [];
          if (!products.length) {
            showStatus('Keine Produkte für „' + query + '“');
            if (allLink) {
              allLink.hidden = false;
              allLink.href = '/search?type=product&q=' + encodeURIComponent(query);
            }
            return;
          }
          renderProducts(products, query);
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          if (query !== lastQuery) return;
          showStatus('Suche vorübergehend nicht verfügbar. Bitte Enter drücken.');
        });
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        if (modal.hidden) openSearch();
        else closeSearch();
      });
    });

    modal.querySelectorAll('[data-search-close]').forEach(function (el) {
      el.addEventListener('click', closeSearch);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hidden) {
        e.preventDefault();
        closeSearch();
      }
      if ((e.key === 'k' || e.key === 'K') && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        openSearch();
      }
    });

    if (input) {
      input.addEventListener('input', function () {
        var query = (input.value || '').trim();
        window.clearTimeout(debounceTimer);
        debounceTimer = window.setTimeout(function () {
          runPredictive(query);
        }, 220);
      });

      if ((input.value || '').trim()) {
        runPredictive(input.value.trim());
      }
    }

    if (clearBtn && input) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        runPredictive('');
      });
    }
  }

  function isInViewport(el) {
    var rect = el.getBoundingClientRect();
    return rect.top < window.innerHeight && rect.bottom > 0;
  }

  function initReveal() {
    var items = document.querySelectorAll('[data-vy-reveal]');
    if (!items.length) return;

    function reveal(el) {
      el.classList.add('is-visible');
    }

    items.forEach(function (el) {
      if (isInViewport(el)) reveal(el);
    });

    if (!('IntersectionObserver' in window)) {
      items.forEach(reveal);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          reveal(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0, rootMargin: '0px 0px 8% 0px' });

    items.forEach(function (el) {
      if (!el.classList.contains('is-visible')) {
        observer.observe(el);
      }
    });

    window.setTimeout(function () {
      items.forEach(function (el) {
        if (!el.classList.contains('is-visible')) reveal(el);
      });
    }, 2000);
  }

  function initParallax() {
    /* Hero parallax disabled — moving only the image exposed the overlay/box gap on scroll. */
  }

  function initSliders() {
    var sliders = document.querySelectorAll('[data-vy-slider-track]');
    sliders.forEach(function (track) {
      var section = track.closest('.vy-new-in');
      if (!section) return;
      var prev = section.querySelector('[data-vy-slider-prev]');
      var next = section.querySelector('[data-vy-slider-next]');
      if (!prev || !next) return;

      function stepSize() {
        var slide = track.querySelector('.vy-new-in__slide');
        if (!slide) return track.clientWidth;
        var style = window.getComputedStyle(track);
        var gap = parseFloat(style.columnGap || style.gap || '0') || 0;
        var slideWidth = slide.getBoundingClientRect().width + gap;
        var perView = Math.max(1, Math.floor(track.clientWidth / slideWidth));
        return slideWidth * perView;
      }

      function updateArrows() {
        var maxScroll = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= maxScroll;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -stepSize(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: stepSize(), behavior: 'smooth' });
      });

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(updateArrows);
      }, { passive: true });
      window.addEventListener('resize', updateArrows, { passive: true });
      updateArrows();

      initDrag(track);
    });
  }

  function initDrag(track) {
    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScroll = 0;
    var pointerId = null;
    var suppressClick = false;
    var clearTimer = null;

    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return;
      if (e.target.closest('a, button, input, [data-vy-quickadd], [data-vy-card-swatch]')) return;
      isDown = true;
      moved = false;
      suppressClick = false;
      if (clearTimer) { clearTimeout(clearTimer); clearTimer = null; }
      pointerId = e.pointerId;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      track.style.scrollSnapType = 'none';
    });

    track.addEventListener('pointermove', function (e) {
      if (!isDown) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 6) {
        moved = true;
        track.classList.add('is-grabbing');
      }
      track.scrollLeft = startScroll - dx;
    });

    function endDrag() {
      if (!isDown) return;
      isDown = false;
      track.classList.remove('is-grabbing');
      track.style.scrollSnapType = '';
      // Only swallow the synthetic click after a *real* drag — i.e. one that
      // actually scrolled the track. A plain click (even with tiny trackpad
      // jitter) never scrolls, so it always navigates.
      var scrolled = Math.abs(track.scrollLeft - startScroll) > 8;
      if (moved && scrolled) {
        suppressClick = true;
        clearTimer = setTimeout(function () { suppressClick = false; clearTimer = null; }, 120);
      }
      moved = false;
      if (pointerId !== null && track.releasePointerCapture) {
        try { track.releasePointerCapture(pointerId); } catch (err) {}
      }
      pointerId = null;
    }

    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);

    track.addEventListener('click', function (e) {
      if (suppressClick) {
        e.preventDefault();
        e.stopPropagation();
        suppressClick = false;
        if (clearTimer) { clearTimeout(clearTimer); clearTimer = null; }
      }
    }, true);

    track.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return (cents / 100).toFixed(2) + ' €';
  }

  function initVyProduct() {
    var section = document.querySelector('[data-vy-product]');
    if (!section) return;

    var jsonEl = section.querySelector('[data-vy-product-json]');
    var form = section.querySelector('[data-vy-product-form]');
    if (!jsonEl || !form) return;

    var product;
    try {
      product = JSON.parse(jsonEl.textContent);
    } catch (e) {
      return;
    }

    var variantInput = form.querySelector('[data-vy-variant-id]');
    var priceEl = section.querySelector('[data-vy-product-price]');
    var stickyPriceEl = section.querySelector('[data-vy-sticky-price]');
    var submitBtn = form.querySelector('[data-vy-add-to-cart]');
    var stickyBar = section.querySelector('[data-vy-sticky-atc]');
    var stickyBtn = section.querySelector('[data-vy-sticky-atc-btn]');
    var mainAtc = section.querySelector('[data-vy-main-atc]');

    function getSelectedOptions() {
      var options = [];
      form.querySelectorAll('[data-vy-option]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-vy-option-input]:checked');
        if (checked) options.push(checked.value);
      });
      return options;
    }

    function findVariant(options) {
      return product.variants.find(function (variant) {
        return variant.options.every(function (opt, i) {
          return !options[i] || opt === options[i];
        });
      });
    }

    function renderPriceHtml(variant) {
      var html = '<div class="price">';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html += '<s class="price__compare">' + formatMoney(variant.compare_at_price) + '</s> ';
        html += '<span class="price__sale">' + formatMoney(variant.price) + '</span>';
      } else {
        html += '<span class="price__regular">' + formatMoney(variant.price) + '</span>';
      }
      html += '</div>';
      return html;
    }

    function syncOptionLabels() {
      form.querySelectorAll('[data-vy-option]').forEach(function (fieldset) {
        var checked = fieldset.querySelector('[data-vy-option-input]:checked');
        var position = fieldset.getAttribute('data-option-index');
        var currentEl = fieldset.parentElement
          ? fieldset.querySelector('[data-vy-option-current="' + position + '"]')
          : null;
        if (!currentEl) {
          currentEl = section.querySelector('[data-vy-option-current="' + position + '"]');
        }
        fieldset.querySelectorAll('.vy-product__value').forEach(function (label) {
          var input = label.querySelector('input');
          label.classList.toggle('is-selected', !!(input && input.checked));
        });
        if (checked && currentEl) {
          currentEl.textContent = checked.value;
        }
      });
    }

    function setGalleryMedia(mediaId) {
      if (!mediaId) return;
      var matchedSlide = null;
      section.querySelectorAll('[data-vy-gallery-slide]').forEach(function (slide) {
        var isMatch = String(slide.getAttribute('data-media-id')) === String(mediaId);
        slide.classList.toggle('is-active', isMatch);
        if (isMatch) matchedSlide = slide;
      });
      section.querySelectorAll('[data-vy-gallery-thumb]').forEach(function (thumb) {
        var isMatch = String(thumb.getAttribute('data-media-id')) === String(mediaId);
        thumb.classList.toggle('is-active', isMatch);
        thumb.setAttribute('aria-selected', isMatch ? 'true' : 'false');
      });
      var track = section.querySelector('[data-vy-gallery-track]');
      if (track && matchedSlide && window.matchMedia('(max-width: 989px)').matches) {
        track.scrollTo({ left: matchedSlide.offsetLeft, behavior: 'smooth' });
      }
    }

    function resolveGalleryMediaId(variant) {
      // Prefer swatch data-media-id (Liquid media.id). featured_image.id is a
      // different Image id and will not match gallery data-media-id attributes.
      var colorMediaInput = form.querySelector('[data-vy-option-input][data-media-id]:checked');
      if (colorMediaInput) {
        return colorMediaInput.getAttribute('data-media-id');
      }
      if (variant && variant.featured_media && variant.featured_media.id) {
        return variant.featured_media.id;
      }
      if (variant && variant.featured_image && variant.featured_image.src) {
        var src = String(variant.featured_image.src).split('?')[0];
        var matched = null;
        section.querySelectorAll('[data-vy-gallery-slide]').forEach(function (slide) {
          var img = slide.querySelector('img');
          if (!img || !img.getAttribute('src')) return;
          var slideSrc = String(img.getAttribute('src')).split('?')[0];
          if (slideSrc === src || slideSrc.indexOf(src.split('/').pop()) !== -1 || src.indexOf(slideSrc.split('/').pop()) !== -1) {
            matched = slide.getAttribute('data-media-id');
          }
        });
        if (matched) return matched;
      }
      return null;
    }

    function initStickyAtc() {
      if (!stickyBar || !mainAtc) return;
      stickyBar.removeAttribute('hidden');
      if (submitBtn && submitBtn.disabled) {
        stickyBar.setAttribute('hidden', '');
        return;
      }
      if ('IntersectionObserver' in window) {
        var mainAtcVisible = true;
        var relatedVisible = false;

        function syncStickyAtc() {
          if (submitBtn && submitBtn.disabled) {
            stickyBar.classList.remove('is-visible');
            return;
          }
          stickyBar.classList.toggle('is-visible', !mainAtcVisible && !relatedVisible);
        }

        var mainObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            mainAtcVisible = entry.isIntersecting;
            syncStickyAtc();
          });
        }, { threshold: 0, rootMargin: '0px 0px -12px 0px' });
        mainObserver.observe(mainAtc);

        var relatedSection = section.querySelector('.vy-product__related');
        if (relatedSection) {
          var relatedObserver = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
              relatedVisible = entry.isIntersecting;
              syncStickyAtc();
            });
          }, { threshold: 0, rootMargin: '0px 0px -8px 0px' });
          relatedObserver.observe(relatedSection);
        }
      }
      if (stickyBtn) {
        stickyBtn.addEventListener('click', function () {
          if (submitBtn && !submitBtn.disabled) {
            submitBtn.click();
          }
        });
      }
    }

    function initMobileGallery() {
      var track = section.querySelector('[data-vy-gallery-track]');
      if (!track) return;
      var slides = track.querySelectorAll('[data-vy-gallery-slide]');
      var mq = window.matchMedia('(max-width: 989px)');

      function syncFromScroll() {
        if (!mq.matches || slides.length < 2) return;
        var index = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        index = Math.max(0, Math.min(index, slides.length - 1));
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === index);
        });
        section.querySelectorAll('[data-vy-gallery-thumb]').forEach(function (thumb, i) {
          var active = i === index;
          thumb.classList.toggle('is-active', active);
          thumb.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      track.addEventListener('scroll', function () {
        window.requestAnimationFrame(syncFromScroll);
      }, { passive: true });

      section.querySelectorAll('[data-vy-gallery-thumb]').forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          if (mq.matches && slides[i]) {
            track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
          }
        });
      });
    }

    function updateVariant(variant) {
      if (!variant) return;
      if (variantInput) variantInput.value = variant.id;
      var priceHtml = renderPriceHtml(variant);
      if (priceEl) priceEl.innerHTML = priceHtml;
      if (stickyPriceEl) stickyPriceEl.innerHTML = priceHtml;
      if (submitBtn) {
        submitBtn.disabled = !variant.available;
        submitBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (stickyBtn) {
        stickyBtn.disabled = !variant.available;
        stickyBtn.textContent = variant.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (stickyBar) {
        if (!variant.available) {
          stickyBar.classList.remove('is-visible');
          stickyBar.setAttribute('hidden', '');
        } else {
          stickyBar.removeAttribute('hidden');
        }
      }
      syncOptionLabels();
      var mediaId = resolveGalleryMediaId(variant);
      if (mediaId) setGalleryMedia(mediaId);
    }

    form.querySelectorAll('[data-vy-option-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var variant = findVariant(getSelectedOptions());
        if (variant) {
          updateVariant(variant);
          return;
        }
        syncOptionLabels();
        var mediaId = resolveGalleryMediaId(null);
        if (mediaId) setGalleryMedia(mediaId);
      });
    });

    section.querySelectorAll('[data-vy-gallery-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        setGalleryMedia(thumb.getAttribute('data-media-id'));
      });
    });

    initStickyAtc();
    initMobileGallery();
    syncOptionLabels();

    if (getCartType() === 'drawer') {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var variant = findVariant(getSelectedOptions());
        if (!variant || !variant.available) return;
        var qtyInput = form.querySelector('[name="quantity"]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Wird hinzugefügt …';
        }
        addItemToCart(variant.id, qty)
          .then(function (cart) {
            updateCartCount(cart.item_count);
            openCartDrawer();
          })
          .catch(function () {
            form.submit();
          })
          .finally(function () {
            var current = findVariant(getSelectedOptions());
            if (submitBtn && current) {
              submitBtn.disabled = !current.available;
              submitBtn.textContent = current.available ? 'In den Warenkorb' : 'Ausverkauft';
            }
          });
      });
    }
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      var parent = el.closest('[data-cart-drawer-open], .vy-header__cart');
      if (parent && parent.getAttribute('aria-label')) {
        var base = parent.getAttribute('aria-label').replace(/\s*\(\d+\)\s*$/, '').trim();
        parent.setAttribute('aria-label', base + ' (' + count + ')');
      }
    });
  }

  function getCartType() {
    return (window.Vayrani && window.Vayrani.cartType) || 'drawer';
  }

  function addItemToCart(variantId, quantity) {
    var routes = window.Vayrani && window.Vayrani.routes;
    if (!routes || !routes.cartAdd) {
      return Promise.reject(new Error('cart routes missing'));
    }
    return fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add failed');
        return fetch(routes.cartJson, { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); });
  }

  function changeCartLine(lineKey, quantity) {
    var routes = window.Vayrani && window.Vayrani.routes;
    if (!routes || !routes.cartChange) {
      return Promise.reject(new Error('cart routes missing'));
    }
    return fetch(routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: quantity })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('change failed');
        return fetch(routes.cartJson, { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); });
  }

  var cartDrawerLastFocus = null;
  var cartDrawerQtyTimer = null;

  function refreshCartDrawerContent(contentEl) {
    var routes = window.Vayrani && window.Vayrani.routes;
    if (!routes || !contentEl) return Promise.resolve();
    contentEl.setAttribute('aria-busy', 'true');
    return fetch(routes.cartUrl + '?section_id=cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-content]');
        if (fresh) contentEl.innerHTML = fresh.innerHTML;
      })
      .finally(function () {
        contentEl.removeAttribute('aria-busy');
      });
  }

  function openCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    var contentEl = drawer.querySelector('[data-cart-drawer-content]');
    cartDrawerLastFocus = document.activeElement;
    drawer.hidden = false;
    drawer.removeAttribute('inert');
    document.body.style.overflow = 'hidden';
    refreshCartDrawerContent(contentEl).then(function () {
      var closeBtn = drawer.querySelector('[data-cart-drawer-close].vy-cart-drawer__close');
      if (closeBtn) closeBtn.focus();
    });
  }
  window.VayraniOpenCartDrawer = openCartDrawer;

  function closeCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;
    drawer.hidden = true;
    drawer.setAttribute('inert', '');
    document.body.style.overflow = '';
    if (cartDrawerLastFocus && typeof cartDrawerLastFocus.focus === 'function') {
      cartDrawerLastFocus.focus();
    }
    cartDrawerLastFocus = null;
  }

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer) return;

    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openCartDrawer();
      });
    });

    drawer.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-drawer-close]')) {
        closeCartDrawer();
      }
    });

    drawer.addEventListener('change', function (e) {
      var input = e.target.closest('[data-cart-drawer-qty]');
      if (!input) return;
      var lineKey = input.getAttribute('data-line-key');
      var qty = parseInt(input.value, 10);
      if (!lineKey || isNaN(qty)) return;
      window.clearTimeout(cartDrawerQtyTimer);
      cartDrawerQtyTimer = window.setTimeout(function () {
        var contentEl = drawer.querySelector('[data-cart-drawer-content]');
        changeCartLine(lineKey, Math.max(0, qty))
          .then(function (cart) {
            updateCartCount(cart.item_count);
            return refreshCartDrawerContent(contentEl);
          })
          .catch(function () {
            return refreshCartDrawerContent(contentEl);
          });
      }, 350);
    });

    drawer.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cart-drawer-remove]');
      if (!removeBtn) return;
      var lineKey = removeBtn.getAttribute('data-line-key');
      if (!lineKey) return;
      var contentEl = drawer.querySelector('[data-cart-drawer-content]');
      changeCartLine(lineKey, 0)
        .then(function (cart) {
          updateCartCount(cart.item_count);
          return refreshCartDrawerContent(contentEl);
        })
        .catch(function () {
          return refreshCartDrawerContent(contentEl);
        });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || drawer.hidden) return;
      closeCartDrawer();
    });
  }

  window.Vayrani = window.Vayrani || {};
  window.Vayrani.openCartDrawer = openCartDrawer;
  window.Vayrani.closeCartDrawer = closeCartDrawer;
  window.Vayrani.addItemToCart = addItemToCart;

  function initQuickAdd() {
    document.querySelectorAll('[data-vy-quickadd]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.vy-product-card__quickadd-btn');
        var label = form.querySelector('.vy-product-card__quickadd-label');
        var idInput = form.querySelector('[data-vy-quickadd-id]');
        if (!idInput || !idInput.value) return;
        if (form.classList.contains('is-busy')) return;

        form.classList.add('is-busy');
        var original = label ? label.textContent : '';
        if (label) label.textContent = 'Wird hinzugefügt …';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(idInput.value), quantity: 1 }] })
        })
          .then(function (r) {
            if (!r.ok) throw new Error('add failed');
            return fetch('/cart.js', { headers: { Accept: 'application/json' } });
          })
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            updateCartCount(cart.item_count);
            if (getCartType() === 'drawer') {
              openCartDrawer();
            }
            if (label) label.textContent = 'Hinzugefügt ✓';
            window.setTimeout(function () {
              if (label) label.textContent = original;
              form.classList.remove('is-busy');
            }, 1600);
          })
          .catch(function () {
            if (label) label.textContent = 'Fehler — erneut';
            window.setTimeout(function () {
              if (label) label.textContent = original;
              form.classList.remove('is-busy');
            }, 1800);
          });
      });
    });
  }

  function initCardSwatches() {
    document.querySelectorAll('[data-vy-card]').forEach(function (card) {
      var swatches = card.querySelectorAll('[data-vy-card-swatch]');
      if (!swatches.length) return;
      var img = card.querySelector('[data-vy-card-image]');
      var idInput = card.querySelector('[data-vy-quickadd-id]');
      var defaultSrc = img ? img.getAttribute('src') : null;

      swatches.forEach(function (sw) {
        sw.addEventListener('mouseenter', function () {
          var media = sw.getAttribute('data-media');
          if (img && media) img.setAttribute('src', media);
        });
        sw.addEventListener('click', function () {
          swatches.forEach(function (s) { s.classList.remove('is-active'); });
          sw.classList.add('is-active');
          var media = sw.getAttribute('data-media');
          var vid = sw.getAttribute('data-variant');
          if (img && media) {
            defaultSrc = media;
            img.setAttribute('src', media);
            img.removeAttribute('srcset');
          }
          if (idInput && vid) idInput.value = vid;
        });
      });

      card.addEventListener('mouseleave', function () {
        if (img && defaultSrc) img.setAttribute('src', defaultSrc);
      });
    });
  }

  function initScrollTo() {
    var offset = 102;
    document.querySelectorAll('[data-vy-scroll-to]').forEach(function (el) {
      el.addEventListener('click', function (e) {
        var id = el.getAttribute('data-vy-scroll-to');
        var target = id && document.getElementById(id);
        if (!target) return;
        e.preventDefault();
        var y = target.getBoundingClientRect().top + window.scrollY - offset;
        window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' });
      });
    });
  }

  function initHeroIntro() {
    var hero = document.querySelector('[data-vy-hero]');
    if (!hero) return;
    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        hero.classList.add('is-intro-loaded');
      });
    });
  }

  function initCollectionToolbar() {
    var root = document.querySelector('[data-vy-collection]');
    if (!root) return;

    var toolbar = root.querySelector('[data-vy-collection-toolbar]');
    var sentinel = root.querySelector('[data-vy-collection-toolbar-sentinel]');
    var spacer = root.querySelector('[data-vy-collection-toolbar-spacer]');
    var mq = window.matchMedia('(max-width: 989px)');

    if (!toolbar || !sentinel || !spacer) return;

    var observer = null;

    function headerOffsetPx() {
      if (document.body.classList.contains('vy-header-hidden')) return 0;
      var header = document.querySelector('[data-vy-header]');
      if (!header) return 92;
      return Math.round(header.getBoundingClientRect().bottom);
    }

    function syncSpacer() {
      if (toolbar.classList.contains('is-fixed')) {
        spacer.hidden = false;
        spacer.style.height = toolbar.offsetHeight + 'px';
      } else {
        spacer.hidden = true;
        spacer.style.height = '0';
      }
    }

    function bindObserver() {
      if (observer) {
        observer.disconnect();
        observer = null;
      }

      if (!mq.matches) {
        toolbar.classList.remove('is-fixed');
        syncSpacer();
        return;
      }

      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            toolbar.classList.toggle('is-fixed', !entry.isIntersecting);
            syncSpacer();
          });
        },
        {
          root: null,
          threshold: 0,
          rootMargin: '-' + headerOffsetPx() + 'px 0px 0px 0px'
        }
      );

      observer.observe(sentinel);
      syncSpacer();
    }

    bindObserver();
    mq.addEventListener('change', bindObserver);
    window.addEventListener('resize', syncSpacer);

    var headerWatch = new MutationObserver(bindObserver);
    headerWatch.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  function initCollectionFilters() {
    var root = document.querySelector('[data-vy-collection]');
    if (!root) return;

    var form = root.querySelector('[data-vy-collection-filters-form]');
    if (!form) return;

    var panel = root.querySelector('[data-vy-collection-filters-panel]');
    var overlay = root.querySelector('[data-vy-collection-filters-overlay]');
    var openBtn = root.querySelector('[data-vy-collection-filters-open]');
    var closeBtn = root.querySelector('[data-vy-collection-filters-close]');
    var sortSelects = root.querySelectorAll('[data-vy-collection-sort]');
    var mobileMq = window.matchMedia('(max-width: 749px)');

    function isMobile() {
      return mobileMq.matches;
    }

    function openFilters() {
      if (!panel || !overlay || !openBtn) return;
      panel.classList.add('is-open');
      overlay.classList.add('is-visible');
      openBtn.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeFilters() {
      if (!panel || !overlay || !openBtn) return;
      panel.classList.remove('is-open');
      overlay.classList.remove('is-visible');
      openBtn.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    sortSelects.forEach(function (sel) {
      sel.addEventListener('change', function () {
        sortSelects.forEach(function (other) {
          if (other !== sel) other.value = sel.value;
        });
        form.submit();
      });
    });

    form.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (!isMobile()) form.submit();
      });
    });

    form.querySelectorAll('[data-vy-filter-always-open]').forEach(function (details) {
      details.addEventListener('toggle', function () {
        if (!details.open) details.open = true;
      });
    });

    form.querySelectorAll('[data-vy-price-slider]').forEach(function (slider) {
      var maxEuros = parseInt(slider.getAttribute('data-price-max'), 10) || 0;
      var minRange = slider.querySelector('[data-vy-price-range-min]');
      var maxRange = slider.querySelector('[data-vy-price-range-max]');
      var minHidden = slider.querySelector('[data-vy-price-min]');
      var maxHidden = slider.querySelector('[data-vy-price-max]');
      var fill = slider.querySelector('[data-vy-price-fill]');
      var displayMin = slider.querySelector('[data-vy-price-display-min]');
      var displayMax = slider.querySelector('[data-vy-price-display-max]');
      var sliderTimer;

      if (!minRange || !maxRange || !maxEuros) return;

      function formatEuro(amount) {
        return formatMoney(Math.round(amount * 100));
      }

      function syncHiddenInputs() {
        var min = parseInt(minRange.value, 10);
        var max = parseInt(maxRange.value, 10);

        if (minHidden) {
          var minName = minHidden.getAttribute('data-param-name');
          if (min > 0) {
            minHidden.setAttribute('name', minName);
            minHidden.value = String(min);
          } else {
            minHidden.removeAttribute('name');
            minHidden.value = '';
          }
        }

        if (maxHidden) {
          var maxName = maxHidden.getAttribute('data-param-name');
          if (max < maxEuros) {
            maxHidden.setAttribute('name', maxName);
            maxHidden.value = String(max);
          } else {
            maxHidden.removeAttribute('name');
            maxHidden.value = '';
          }
        }
      }

      function updateSliderUi() {
        var min = parseInt(minRange.value, 10);
        var max = parseInt(maxRange.value, 10);
        var span = maxEuros || 1;
        var left = (min / span) * 100;
        var width = ((max - min) / span) * 100;

        if (fill) {
          fill.style.left = left + '%';
          fill.style.width = width + '%';
        }
        if (displayMin) displayMin.textContent = formatEuro(min);
        if (displayMax) displayMax.textContent = formatEuro(max);
        syncHiddenInputs();
      }

      function onSliderInput(e) {
        var min = parseInt(minRange.value, 10);
        var max = parseInt(maxRange.value, 10);

        if (min > max) {
          if (e.target === minRange) {
            maxRange.value = String(min);
          } else {
            minRange.value = String(max);
          }
        }

        updateSliderUi();
      }

      function onSliderCommit() {
        updateSliderUi();
        if (isMobile()) return;
        window.clearTimeout(sliderTimer);
        sliderTimer = window.setTimeout(function () {
          form.submit();
        }, 400);
      }

      minRange.addEventListener('input', onSliderInput);
      maxRange.addEventListener('input', onSliderInput);
      minRange.addEventListener('change', onSliderCommit);
      maxRange.addEventListener('change', onSliderCommit);
      updateSliderUi();
    });

    if (openBtn) openBtn.addEventListener('click', openFilters);
    if (closeBtn) closeBtn.addEventListener('click', closeFilters);
    if (overlay) overlay.addEventListener('click', closeFilters);

    form.addEventListener('submit', function () {
      if (isMobile()) closeFilters();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && panel && panel.classList.contains('is-open')) {
        closeFilters();
      }
    });
  }

  /* Reopen Pandectes without paid "Custom open/reopen".
     Pierces the open shadow root of <pandectes-cmp> and clicks the plan-included reopen widget. */
  function initCookieSettings() {
    function collectButtons(root, out) {
      if (!root) return out;
      root.querySelectorAll('button').forEach(function (btn) { out.push(btn); });
      root.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) collectButtons(el.shadowRoot, out);
      });
      return out;
    }

    function findReopenWidget() {
      var buttons = collectButtons(document, []);
      for (var i = 0; i < buttons.length; i += 1) {
        var btn = buttons[i];
        var label = ((btn.getAttribute('aria-label') || '') + ' ' + (btn.textContent || '') + ' ' + (btn.className || '')).trim();
        if (/einwilligung|cookie-einstellungen|change your consent|manage cookies|reopen|\bwidget\b/i.test(label)) {
          return btn;
        }
      }
      var host = document.querySelector('pandectes-cmp');
      if (host && host.shadowRoot) {
        return host.shadowRoot.querySelector('button.widget, button[class*="widget"]');
      }
      return null;
    }

    function openPandectes() {
      var P = window.Pandectes;
      if (P && typeof P.openDialog === 'function') {
        try {
          P.openDialog('notice');
          return true;
        } catch (err) {
          /* fall through to widget */
        }
      }
      var widget = findReopenWidget();
      if (widget) {
        widget.click();
        return true;
      }
      return false;
    }

    function onClick(event) {
      var link = event.target && event.target.closest
        ? event.target.closest('a[href="#reopenBanner"], a[href*="#reopenBanner"], [data-vy-cookie-settings]')
        : null;
      if (!link) return;
      event.preventDefault();
      if (openPandectes()) return;
      var attempts = 0;
      var timer = window.setInterval(function () {
        attempts += 1;
        if (openPandectes() || attempts >= 20) window.clearInterval(timer);
      }, 150);
    }

    document.addEventListener('click', onClick, true);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initHeader();
    initMenu();
    initHeaderNav();
    initSearch();
    initHeroIntro();
    initCollectionToolbar();
    initCollectionFilters();
    initReveal();
    initParallax();
    initSliders();
    initScrollTo();
    initVyProduct();
    initCartDrawer();
    initQuickAdd();
    initCardSwatches();
    initCookieSettings();
  });
})();

